'use client'
import { useTranslate } from '../../hooks'
import { ButtonLink, PaymentType } from '../'
import {
  Alert,
  Card,
  CenterBox,
  Col,
  Icon,
  Row,
  Typography,
} from '@repo/ui/components'

export const TransactionError = ({
  amount,
  rrn,
}: {
  amount?: number
  rrn?: string
}) => {
  const { t } = useTranslate()

  return (
    <Card className=' max-w-screen-2xs w-full m-auto flex justify-center items-center'>
      <CenterBox className='h-full w-full '>
        <Col className='gap-md items-center'>
          <CenterBox className='bg-neutral-surface-100/20 rounded-full'>
            <Icon
              name='XmarkCircleGhost'
              className='size-full rounded-full'
              size='2xl'
              color='fill-neutral-surface-100'
            />
          </CenterBox>

          <Typography
            size='lg'
            weight='bold'
            color='text-neutral-surface-80'
            className='text-center'
          >
            {t('common_transaction_error_title')}
          </Typography>
          <Alert
            color='alert'
            size='md'
            caption={t('common_transaction_error_description')}
            icon={<Icon name='AlertTriangleLine' />}
          />
          <Row className='justify-between mt-md'>
            <Typography
              size='sm'
              weight='regular'
              color='text-neutral-surface-80'
            >
              {t('common_transaction_amount')}
            </Typography>
            <PaymentType
              size='sm'
              color='text-neutral-surface-80'
              isBold={false}
              value={amount}
            />
          </Row>
          <Row className='justify-between mt-md'>
            <Typography
              size='sm'
              weight='regular'
              color='text-neutral-surface-80'
            >
              {t('common_transaction_reference')}
            </Typography>
            <Typography size='sm' weight='bold' color='text-neutral-surface-80'>
              <span className='px-2xs'>{rrn ?? '-'}</span>
            </Typography>
          </Row>
          <ButtonLink
            href='/history/balance'
            color='base'
            variant='ghost'
            size='md'
            width='full'
            className='w-full'
          >
            {t('common_transaction_error_button')}
          </ButtonLink>
        </Col>
      </CenterBox>
    </Card>
  )
}
